import { render, staticRenderFns } from "./FeatureProFaq.vue?vue&type=template&id=1d5af3c2&"
import script from "./FeatureProFaq.vue?vue&type=script&lang=js&"
export * from "./FeatureProFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports